import styled from "styled-components";
import spinner from "/assets/rd-bowtie-anim-transp.gif";

const StyledSpinnerWrapper = styled.div`
  text-align: center;
  margin: 25px 0px;
`;

const Spinner = styled.img`
  height: 75px;
`;

type LoadingSpinnerProps = {
  hostname: string;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ hostname }) => {
  const spinnerSrc = `https://${hostname}${spinner}`;

  return (
    <StyledSpinnerWrapper data-id="loading-spinner-container">
      <Spinner src={spinnerSrc} data-id="loading-spinner" />
    </StyledSpinnerWrapper>
  );
};

export default LoadingSpinner;
